export const SocialTradingFeesTypeEnum = {
  Subscription: "Subscription",
  Provider: "Provider",
};
